import { render } from "./SinglePocEditors.vue?vue&type=template&id=2968c50a&scoped=true"
import script from "./SinglePocEditors.vue?vue&type=script&lang=js"
export * from "./SinglePocEditors.vue?vue&type=script&lang=js"

import "./SinglePocEditors.vue?vue&type=style&index=0&id=2968c50a&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2968c50a"]])

export default __exports__